"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawable = exports.CollectionModelDrawableMutator = exports.insightOffsetClassDetections = void 0;
var core_api_1 = require("@ikegps/core-api");
var __1 = require("../..");
var unit_1 = require("../../../unit");
var drawable_state_1 = require("./drawable.state");
exports.insightOffsetClassDetections = ['zero_offset', 'nine_feet_marker', 'six_feet_marker', 'three_feet_marker'];
var CollectionModelDrawableMutator = /** @class */ (function () {
    function CollectionModelDrawableMutator(drawable) {
        this.drawable = drawable;
    }
    /**
     * Move the drawable to this location.
     *
     * Drawable will be constrained to capture bounds.
     *
     * @param x coordinates in pixels
     * @param y coordinates in pixels
     */
    CollectionModelDrawableMutator.prototype.move = function (x, y) {
        var bounds = this.getPointsInBounds(x, y);
        var state = this.getValue();
        state.x = bounds.x;
        state.y = bounds.y;
        this.setValue(state);
    };
    CollectionModelDrawableMutator.prototype.moveNoBounds = function (x, y) {
        var state = this.getValue();
        state.x = x;
        state.y = y;
        this.setValue(state);
    };
    CollectionModelDrawableMutator.prototype.setPosition = function (x, y) {
        var state = this.getValue();
        state.x = x;
        state.y = y;
        this.setValue(state);
    };
    CollectionModelDrawableMutator.prototype.setInsight = function (insight) {
        var state = this.getValue();
        state.insight = insight;
        this.setValue(state);
    };
    CollectionModelDrawableMutator.prototype.getPointsInBounds = function (x, y) {
        if (this.drawable.drawableState.capture == null) {
            return { x: x, y: y };
        }
        var _a = this.drawable.drawableState.capture.resolution, width = _a.width, height = _a.height;
        return {
            x: Math.min(width, Math.max(0, x)),
            y: Math.min(height, Math.max(0, y))
        };
    };
    CollectionModelDrawableMutator.prototype.setValue = function (state) {
        this.drawable.collectionState.setFieldValue(this.drawable.instanceId, state);
    };
    /** Gives a deep clone of the drawable state */
    CollectionModelDrawableMutator.prototype.getValue = function () {
        return structuredClone(this.drawable.state);
    };
    /**
     * Remove the state of this drawable
     * *Warning:* You will need to unlink & remove the drawable from the list before destroying the state.
     * @see CollectionModelDrawableStateMutator.remove
     */
    CollectionModelDrawableMutator.prototype.destroyState = function () {
        this.drawable.collectionState.setFieldValue(this.drawable.instanceId, null);
    };
    /**
     * Remove the drawable,
     * This will unlink and destroy the drawable and all associated values.
     *
     * @see CollectionModelDrawableStateMutator.remove
     */
    CollectionModelDrawableMutator.prototype.remove = function () {
        this.drawable.drawableState.Mutator.remove(this.drawable);
    };
    /**
     * Transforms the insight marked drawable into a normal drawable
     */
    CollectionModelDrawableMutator.prototype.approveDrawable = function () {
        var state = this.getValue();
        if (state === null || state === void 0 ? void 0 : state.insight) {
            state.insight.applied = true;
        }
        this.setValue(state);
    };
    return CollectionModelDrawableMutator;
}());
exports.CollectionModelDrawableMutator = CollectionModelDrawableMutator;
var CollectionModelDrawable = /** @class */ (function () {
    function CollectionModelDrawable(state, drawableId, captureId) {
        this.instanceId = drawable_state_1.CollectionModelDrawableState.drawableId(captureId, drawableId);
        this.id = drawableId;
        this.captureId = captureId;
        this.drawableState = state;
    }
    CollectionModelDrawable.roundCoord = function (xy) {
        return unit_1.IkeUnit.round(xy, CollectionModelDrawable.PRECISION);
    };
    Object.defineProperty(CollectionModelDrawable.prototype, "state", {
        get: function () {
            return this.collectionState.getFieldValue(this.instanceId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "collectionState", {
        get: function () {
            return this.drawableState.collection.state;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawable.prototype.getChildDrawable = function (id) {
        return null;
    };
    Object.defineProperty(CollectionModelDrawable.prototype, "isDeletable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "insight", {
        get: function () {
            var _a;
            return (_a = this.state) === null || _a === void 0 ? void 0 : _a.insight;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "isUserMeasurement", {
        get: function () {
            var _a;
            return this.tag !== 'mask' && (!this.insight || ((_a = this.insight) === null || _a === void 0 ? void 0 : _a.applied));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "isInsightMeasurement", {
        get: function () {
            return !this.isUserMeasurement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "isVisible", {
        get: function () {
            var _a;
            if (this.isInsightMeasurement) {
                // Show applied insight drawables
                if ((_a = this.insight) === null || _a === void 0 ? void 0 : _a.applied) {
                    return true;
                }
                // If the image already has a base, then hide unapplied insight base/offset markers
                if (this.collectionHasBase) {
                    return !this.isInsightBaseDetectionClass;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "isInsightBaseDetectionClass", {
        get: function () {
            var _a;
            return exports.insightOffsetClassDetections.includes(((_a = this.insight) === null || _a === void 0 ? void 0 : _a.detection_class) || '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawable.prototype, "collectionHasBase", {
        get: function () {
            return !!this.drawableState.base;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawable.prototype.approveInsightFlag = function () {
        var drawableToMutate = this;
        if (__1.CollectionModelDrawableLinePoint.isLinePoint(drawableToMutate) || __1.CollectionModelDrawableLabel.isLabel(drawableToMutate)) {
            var parent_1 = drawableToMutate.parent;
            if (parent_1 != null) {
                drawableToMutate = parent_1;
            }
        }
        // Small optimization to avoid unnecessary state updates
        if (!drawableToMutate.insight || drawableToMutate.insight.applied) {
            return;
        }
        drawableToMutate.Mutator.approveDrawable();
        if (__1.CollectionModelDrawableMarker.isMarker(drawableToMutate)) {
            drawableToMutate.label.Mutator.approveDrawable();
            if (exports.insightOffsetClassDetections.includes(drawableToMutate.insight.detection_class) && !this.drawableState.base) {
                var offsetValue = 0;
                switch (drawableToMutate.insight.detection_class) {
                    case 'nine_feet_marker':
                        offsetValue = 9;
                        break;
                    case 'six_feet_marker':
                        offsetValue = 6;
                        break;
                    case 'three_feet_marker':
                        offsetValue = 3;
                        break;
                    default:
                        break;
                }
                drawableToMutate.Mutator.setType(core_api_1.MarkerType.BASE);
                // this.drawableState.base is now valid as we just set the base type
                this.drawableState.base.Mutator.offset(unit_1.IkeUnit.convert(offsetValue, unit_1.IkeUnit.METER, unit_1.IkeUnit.FEET, core_api_1.IkeUnitType.DISTANCE));
            }
        }
        else if (__1.CollectionModelDrawableMarkerOffset.isBaseOffset(drawableToMutate)) {
            // This should not trigger as we don't support insight base offsets made by the back end yet
            drawableToMutate.label.Mutator.approveDrawable();
        }
        else if (__1.CollectionModelDrawableLine.isLine(drawableToMutate)) {
            // This should not trigger as we don't support insight line markers made by the back end yet
            drawableToMutate.start.Mutator.approveDrawable();
            drawableToMutate.end.Mutator.approveDrawable();
            drawableToMutate.label.Mutator.approveDrawable();
        }
    };
    CollectionModelDrawable.PRECISION = 1;
    return CollectionModelDrawable;
}());
exports.CollectionModelDrawable = CollectionModelDrawable;
//# sourceMappingURL=drawable.js.map